import HeroComponent from '../components/hero';
import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';

export default class AboutController {

  constructor(options) {
    this.options = options;
    console.log('ABOUT CONTROLLER');

    this.ourfarms_hero = new HeroComponent({
      elem      :'section.ourfarms__hero',
      parallaxCopy : true,
    });

    this.ourfarms_farmers = new HeroComponent({
      elem      :'section.ourfarms__farmers',
    });

    $('nav.siteNav__main>div>a.submenu__about').addClass('is-activepage');

    this.YTE = new YouTubeEmbedAPI();

    $('.is-video').click( (e) => {
      e.preventDefault();

      $('div.site__overlay').addClass('is-active');
      $('div.modal').addClass('is-active');

      const videoID = $(e.currentTarget).data('videoid');
      console.log(videoID, $(e.currentTarget));
      this.YTE.createPlayer(videoID);
    });


    $('div.modal').click( (e) => {

      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal').removeClass('is-active');

        if (this.YTE) {
          this.YTE.destroyPlayer();
        }
      }

    });

    this.transitionIn();

  }

  transitionIn() {
    // reveal the home hero text
    $('.ourfarms__hero .cmpnt__hero__copy__cntr').addClass('do-intro');

    setTimeout( () => {
      $('.ourfarms__hero .cmpnt__hero__copy__cntr').removeClass('do-intro start-intro');
    }, 2300);

  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/AboutController.js